import Tree from './Tree';
import InputNumber from './InputNumber';
import MajorTreeSelect from './MajorTreeSelect';

export default {
    Tree,
    InputNumber,
    MajorTreeSelect
}